import {AbstractResourceBuilder} from 'vue3-starter/src/typescript/resource/AbstractResourceBuilder';
import UserResource from '@/brief-hub/user/UserResource';
import * as RawModel from '@/common/api/api-raw-types';

class UserResourceBuilder extends AbstractResourceBuilder<UserResource> {
    protected _buildResource(data: RawModel.BriefUserResource): UserResource {
        return new UserResource({
            links: this.links,
            identityId: data.identityId,
            companyId: data.companyId,
            firstName: data.firstName,
            clientIdentities: data.clientIdentities,
            admin: data.clientAdmin,
            maltAdmin: data.maltAdmin,
            serviceLevelType: data.serviceLevelType,
        });
    }
}

export const userResourceBuilder = new UserResourceBuilder();
